import { IFilters } from '@chess-class/sandbox';
import { paginationBaseFilters } from '@chess-class/sandbox/consts';

export const studentFilters: IFilters = {
  ...paginationBaseFilters,
};
